import React from 'react'
import DiagnosticPopup from '../Components/DiagnosticPopup/DiagnosticPopup'

const DiagnosticPopupView = () => {
  return (
    <div>
        <DiagnosticPopup />
    </div>
  )
}

export default DiagnosticPopupView